import styled from "styled-components";
import { theme } from "../theme";

interface Props {
  value?: string;
  onChange?: (newValue: string) => void;
  disabled?: boolean;
  placeholder?: string;
  autofocus?: boolean;
  type?: 'password' | 'text';
  onEnter?: () => void;
}

export function TextInput(props: Props) {
  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (props.onChange) {
      props.onChange(event.target.value)
    }
  }

  function onKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter') {
      if (props.onEnter) {
        props.onEnter()
      }
    }
  }

  return (
    <input 
      autoFocus={props.autofocus}
      type={props.type}
      placeholder={props.placeholder} 
      disabled={props.disabled} 
      value={props.value} 
      onChange={(e) => onChange(e)} 
      onKeyDown={(e) => onKeyDown(e)} 
      style={{
        fontSize: theme.typography.textSizes.lg,
        display: 'flex',
        textAlign: 'left',
        padding: theme.spacing.xs,
        border: 'none',
        backgroundColor: 'rgba(0,0,0,0.05)',
        borderWidth: 1,
        borderStyle: 'solid', 
        borderColor: 'rgba(0,0,0,0.05)',
        borderRadius: 5,
        width: '100%',
        maxWidth: 300,
        marginBottom: theme.spacing.xxs,
        boxSizing: 'border-box',
      }}
    />
  )
}